import PermissionsPage from "./pages/PermissionsPage";

const permissionRoutes = [
  { path: "/admin/permissions", element: <PermissionsPage /> }
];

export default permissionRoutes;  